import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener("ajax:beforeSend", (event) => {
      // Only this form's own submit becomes a Turbolinks visit. Remote links
      // or forms nested inside it (e.g. a table's delete buttons) bubble their
      // ajax:beforeSend through here too; hijacking those would turn a
      // DELETE into a GET of the record's URL.
      if (event.target !== this.element) return

      const detail = event.detail, xhr = detail[0], options = detail[1]

      Turbolinks.visit(options.url, { action: "replace" })
      event.preventDefault()
    })
  }

}
